function format (sorted) {

    if (!sorted.id) {
		return sorted.text;
	}
	var baseUrl = "/user/pages/images/flags";
	var $sorted = $(
		'<span class="app-sorted-result"><i class="app-sorted-result__point"></i>' + sorted.text + '</span>'
	);
	return $sorted;
} 

function selectSorder(){
	if (!$('.js-select-sorted').length) {
		return false;
	}
	let select = $('.js-select-sorted');
	select.each(function(index, el) {
		$(this).select2({
			templateResult: format,
			width: 'auto',
			theme: 'sorted',
			minimumResultsForSearch: Infinity,
		});
		$(this).on('change', function() {
			$(this).closest('form').trigger('submit');
		})
	});
}

/**
 * Инит модуля
 */
function init() {
	selectSorder();
}

module.exports = {
	init,
};
